import React from "react";

interface DistributorContactDisplayProps {
  label: string;
  name: string | null;
  phone: string | null;
  email: string | null;
}

export default function DistributorContactDisplay({
  label,
  name,
  phone,
  email,
}: DistributorContactDisplayProps) {
  const displayValue = (value: string | null, fallback: string) =>
    value && value.trim().length > 0 ? value : fallback;

  return (
    <>
      <div className="text-xs">{label}</div>
      <div className="font-weight-bold">{displayValue(name, "Name")}</div>
      <div>{displayValue(phone, "Phone Number")}</div>
      {email && email.trim().length > 0 ? (
        <a href={`mailto:${email}`}>{email}</a>
      ) : (
        <div>{displayValue(email, "Email Address")}</div>
      )}
    </>
  );
}
